import { HTMLAttributes } from 'react';

/**
 * SectionDivider — time/section marker (e.g. "Morning"): --accent icon,
 * --text-dim label, hairline rule filling the rest.
 */
export interface SectionDividerProps extends HTMLAttributes<HTMLDivElement> {
  /** Tabler icon name (without `ti-` prefix), e.g. 'sunrise'. */
  icon?: string;
  /** Section label. */
  label?: string;
}

export function SectionDivider({ icon, label, style, ...props }: SectionDividerProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, ...style }} {...props}>
      {icon ? <i className={`ti ti-${icon}`} style={{ color: 'var(--accent)', fontSize: 13 }} /> : null}
      {label ? (
        <span style={{ color: 'var(--text-dim)', fontFamily: 'var(--font-sans)', fontSize: 'var(--fs-eyebrow)', fontWeight: 500 }}>
          {label}
        </span>
      ) : null}
      <span style={{ flex: 1, height: 1, background: 'var(--line)' }} />
    </div>
  );
}

export default SectionDivider;
